import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/add.png'
import _imports_1 from '@/assets/image/download-template.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7e2383ce")

_pushScopeId("data-v-7e2383ce")
const _hoisted_1 = { class: "navigator" }
const _hoisted_2 = { class: "home-content home-content-top" }
const _hoisted_3 = { style: {"padding":"30px 0 30px 50px"} }
const _hoisted_4 = { class: "list-table-header-cell" }
const _hoisted_5 = { class: "list-table-header-title" }
const _hoisted_6 = {
  key: 0,
  class: "list-table-header-button-right"
}
const _hoisted_7 = { class: "item item-left" }
const _hoisted_8 = {
  class: "img-content",
  style: {"margin-top":"50px"}
}
const _hoisted_9 = { class: "button-content" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_11 = { class: "button-area2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_14 = { class: "button-area2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { ref: "form" }
const _hoisted_17 = { class: "home-content home-content-bottom" }
const _hoisted_18 = { style: {"padding":"30px 0 0 50px"} }
const _hoisted_19 = { class: "list-table-header-cell" }
const _hoisted_20 = { class: "list-table-header-title" }
const _hoisted_21 = { class: "list-table-header-button-right" }
const _hoisted_22 = { style: {"padding":"0 30px 0 0"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_item_title = _resolveComponent("item-title")
  const _component_list = _resolveComponent("list")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_office_set_dialog = _resolveComponent("office-set-dialog")
  const _component_community_set_dialog = _resolveComponent("community-set-dialog")
  const _component_pm_set_dialog = _resolveComponent("pm-set-dialog")
  const _component_pm_transfer_dialog = _resolveComponent("pm-transfer-dialog")
  const _component_import_tip = _resolveComponent("import-tip")
  const _component_property_manager_dialog = _resolveComponent("property-manager-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_cus_button, {
        type: _ctx.type==='community'?'blue':'default',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeScene('community'))),
        style: {"padding":"4px 20px"}
      }, {
        default: _withId(() => [
          _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllCommunity), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_cus_button, {
        type: _ctx.type==='office'?'blue':'default',
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeScene('office'))),
        class: "margin-left10px",
        style: {"padding":"4px 20px"}
      }, {
        default: _withId(() => [
          _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllOffice), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_item_title, {
              name: `${_ctx.total} ${_ctx.ChangeWordList.Projects}`
            }, null, 8, ["name"])
          ]),
          (_ctx.isShowBatchPayment)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_cus_button, {
                  type: "blue",
                  onClick: _ctx.goBatchSubscription
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.NavInHtmlMenuPurchase), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("img", {
              src: require(_ctx.isOffice?'@/assets/image/home-office.png':'@/assets/image/home-community.png')
            }, null, 8, ["src"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", {
              class: "button-bg display-flex justify-content-center align-items-center",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addProject && _ctx.addProject(...args)))
            }, [
              _hoisted_10,
              _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$wordList.ProperAllTextNew), 1)
            ]),
            _hoisted_12,
            _createVNode("div", {
              class: "button-bg display-flex justify-content-center align-items-center",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args)))
            }, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$wordList.ProperAllTextDownloadTemplate), 1)
            ]),
            _hoisted_15
          ])
        ]),
        _createVNode(_component_el_scrollbar, { class: "item item-right" }, {
          default: _withId(() => [
            _createVNode(_component_list, {
              update: _ctx.updateToList,
              headers: _ctx.CommunityHeaders,
              action: _ctx.action,
              showDefaultAction: [],
              requestData: _ctx.requestData,
              showCheck: false,
              onEditCommunity: _ctx.editProject,
              onImportCommunity: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setFile($event.ID))),
              onGetProperty: _ctx.getProperty,
              onGetCommunityDetail: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getCommunityInfo($event.Account))),
              onGetTotal: _ctx.getProjectCounts
            }, {
              LocationSlotHeader: _withId((data) => [
                _createVNode("div", {
                  class: "sort-header",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSortRes(`insHome${_ctx.type}`, 'Location')))
                }, [
                  _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
                  _createVNode("img", {
                    src: _ctx.getSortImg(`insHome${_ctx.type}`, 'Location')
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            }, 8, ["update", "headers", "action", "requestData", "onEditCommunity", "onGetProperty", "onGetTotal"]),
            _createVNode("form", _hoisted_16, [
              _createVNode("input", {
                type: "file",
                name: _ctx.isOffice ? 'Office' : 'Community',
                ref: "file",
                accept: ".xlsx",
                style: {"display":"none"},
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.importFile && _ctx.importFile(...args)))
              }, null, 40, ["name"])
            ], 512)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_item_title, {
              name: _ctx.$wordList.PersonalTitleWorker
            }, null, 8, ["name"])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_cus_button, {
              type: "blue",
              onClick: _ctx.propertyManageAdd
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelPropertyManageTitleAdd), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_list, {
            update: _ctx.updateToList,
            headers: _ctx.PropertyHeaders,
            showDefaultAction: [],
            action: _ctx.pmaction,
            requestData: _ctx.PropertyRequestData,
            showCheck: false,
            onEditpm: _ctx.propertyManageEdit,
            onDeletepm: _ctx.propertyManageDelete
          }, null, 8, ["update", "headers", "action", "requestData", "onEditpm", "onDeletepm"])
        ])
      ])
    ]),
    (_ctx.isShowOfficeDialog)
      ? (_openBlock(), _createBlock(_component_office_set_dialog, {
          key: 0,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowOfficeDialog=false)),
          onSuccess: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateToList++)),
          onFeatureSuccess: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateToList++)),
          operaType: _ctx.userDialogOperaType,
          initForm: _ctx.officeFormData
        }, null, 8, ["operaType", "initForm"]))
      : _createCommentVNode("", true),
    (_ctx.isShowCommunityDialog)
      ? (_openBlock(), _createBlock(_component_community_set_dialog, {
          key: 1,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isShowCommunityDialog=false)),
          onSuccess: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateToList++)),
          onFeatureSuccess: _cache[14] || (_cache[14] = ($event: any) => (_ctx.updateToList++)),
          operaType: _ctx.userDialogOperaType,
          initForm: _ctx.formData
        }, null, 8, ["operaType", "initForm"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPmDialog)
      ? (_openBlock(), _createBlock(_component_pm_set_dialog, {
          key: 2,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isShowPmDialog = false)),
          onSuccess: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateToList++)),
          operaType: _ctx.pmDialogOperaType,
          initForm: _ctx.pmFormData
        }, null, 8, ["operaType", "initForm"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPmTransfer)
      ? (_openBlock(), _createBlock(_component_pm_transfer_dialog, {
          key: 3,
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isShowPmTransfer = false)),
          onSuccess: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateToList++)),
          communityID: _ctx.communityID
        }, null, 8, ["communityID"]))
      : _createCommentVNode("", true),
    (_ctx.isShowImportTips)
      ? (_openBlock(), _createBlock(_component_import_tip, {
          key: 4,
          details: _ctx.importDetails,
          onUpdateItemId: _ctx.updateImportItemId,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.pauseSearchImport(true)))
        }, null, 8, ["details", "onUpdateItemId"]))
      : _createCommentVNode("", true),
    (_ctx.isShowPropertyManagerDialog)
      ? (_openBlock(), _createBlock(_component_property_manager_dialog, {
          key: 5,
          onEdit: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isShowPmTransfer=true)),
          onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.isShowPropertyManagerDialog=false)),
          communityID: _ctx.communityID,
          isNew: _ctx.isNewCommunity,
          update: _ctx.updateToList
        }, null, 8, ["communityID", "isNew", "update"]))
      : _createCommentVNode("", true)
  ]))
})